import { Loader } from '../Loader/Loader';
import styles from './LoadingOverlay.module.scss';

interface LoadingOverlayI {
  isLoading: boolean;
}

const LoadingOverlay = ({ isLoading = false }: LoadingOverlayI) => {
  return isLoading ? (
    <div className={styles.overlay}>
      <Loader />
    </div>
  ) : null;
};

export default LoadingOverlay;
